export const EVENT_HEADER_LINK_URL = 'eventHeaderLinkUrl'
export const EVENT_HEADER_IMAGE_URL = 'eventHeaderImageUrl'
export const EVENT_BUTTON_TEXT = 'eventButtonText'

export type EventHeaderConfig = {
  [EVENT_HEADER_LINK_URL]: string
  [EVENT_HEADER_IMAGE_URL]: string
  [EVENT_BUTTON_TEXT]: string
}
